module.exports = __webpack_public_path__ + "static/media/DecNoaction.catalyst.6b6cbb97.tsx";